import React, { useEffect, useState } from 'react';

import './Homepage.css';

import Title from '../Title/Title';
import PrizesAndWeight from '../PrizesAndWeight/PrizesAndWeight';
import ListView from '../ListView/ListView';
import RadarChart from '../RadarChart/RadarChart';
import GetData from './GetData';

const filters = ['CATÉGORIE', 'THÉME', 'ÉMISSION', 'ANNÉE', 'COMPAGNIE', 'TRANCHE NOMBRE PRIX'];
function Homepage() {

  const [radarChartData, setRadarChartData] = useState();

  const [totalCompanies, setTotalCompanies] = useState('-');
  const [totalAwards, setTotalAwards] = useState();
  const [top10, setTop10] = useState();

  //Filters -> year filter, range filter, theme filter
  const [yearFilter, setYearFilter] = useState({
    '2017': true,
    '2018': true,
    '2019': true,
    '2020': true
  });

  const [rangeFilter, setRangeFilter] = useState({
    '1': true,
    '2': true,
    '3': true,
    '4': true,
    '5': true,
    '[6-10[': true,
    '[10-15[': true,
    '[15-20[': true,
    '[20-25[': true,
    '[25-30[': true,
    '[30-35[': true,
    '[35-40[': true,
    '[40-45[': true,
    '[45-50[': true,
    '[50-55[': true,
    '[55-60[': true,
    '> 60': true
  });

  const [themeFilter, setThemeFilter] = useState({
    'AFFAIRES PUBLIQUES' : true,
    'ANIMATION' : true,
    'DOCUMENTAIRE' : true,
    'JEUNESSE' : true,
    'MAGAZINE' : true,
    'REPORTAGE' : true,
    'SPORT' : true,
    'VARIÉTÉ' : true,
    'TOUTES CATÉGORIES' : true, 
    'TALK-SHOW' : true,
    'HUMOUR' : true,
    'FICTION-MASCULIN' : true,
    'FICTION-FEMININ' : true,
    'FICTION' : true
  });

  /*Data to be sent to different charts component
    1. Prizes chart(on top) -> prizesChartData
    2. Weight chart(on top) -> weightChartData
  */
  const [prizesChartData, setPrizesChartData] = useState({
    label: '',
    data: {
      '2017': [],
      '2018': [],
      '2019': [],
      '2020': []
    }
  });

  const [weightChartData, setWeightChartData] = useState({
    top10: 0,
    remaining: 0
  });

  const calculateWeightChartData = (weightData) => {

    let sumTop10 = 0, sumRemaining = 0, index = 0;
    for(index = 0; index < weightData.length; index++) {
      if(index < 10) {
        sumTop10 += weightData[index];
      } else {
        sumRemaining += weightData[index];
      }
    }

    const top10 = ((sumTop10 * 100) / (sumTop10 + sumRemaining)).toString();
    const remaining = ((sumRemaining * 100) / (sumTop10 + sumRemaining)).toString();

    // console.log(top10, remaining);
    setWeightChartData({
      top10: top10,
      remaining: remaining
    });
  } 

  const calculateListViewData = (tempData, prizesData) => {
    
    //Total number of companies 
    const numberOfCompanies = tempData.length;
    setTotalCompanies(numberOfCompanies);

    //Total number of awards = total number of rows selected
    const numberOfAwards = prizesData.length;
    setTotalAwards(numberOfAwards);

    //Top 10 companies
    let top10Companies = [];
    for(let i = 0; i < Math.min(10, tempData.length); i++) {
      top10Companies.push({
        companyName: tempData[i].label,
        awards: tempData[i].count
      });
    }

    setTop10(top10Companies);
  }

  const calculatePrizesChartData = (prizesData) => {

    let tempData = [];
    prizesData.map(val => {
      //Checking if that company is already present
      //in the array or not
      const index = tempData.findIndex(obj => {
        return obj.label === val[filters[4]]
      });

      //Not present -> add it
      if(index === -1) {

        if(val[filters[3]] === '2017') {
          tempData.push({
            label: val[filters[4]],
            data: {
              '2017': 1,
              '2018': 0,
              '2019': 0,
              '2020': 0
            },
            count: 1
          });
        } else if(val[filters[3]] === '2018') {
          tempData.push({
            label: val[filters[4]],
            data: {
              '2017': 0,
              '2018': 1,
              '2019': 0,
              '2020': 0
            },
            count: 1
          });
        } else if(val[filters[3]] === '2019') {
          tempData.push({
            label: val[filters[4]],
            data: {
              '2017': 0,
              '2018': 0,
              '2019': 1,
              '2020': 0
            },
            count: 1
          });
        } else if(val[filters[3]] === '2020') {
          tempData.push({
            label: val[filters[4]],
            data: {
              '2017': 0,
              '2018': 0,
              '2019': 0,
              '2020': 1
            },
            count: 1
          });
        }

       //Present -> increase count by 1
      } else {
        tempData[index].data[val[filters[3]]]++;
        tempData[index].count++;
      }
    });

    //Sorting label on the basis of count
    const comparator = (A, B) => {
      return (B.count) - (A.count);
    };
    
    tempData.sort(comparator);
    const parseLabelName = (value) => {
      value = value.toString().replaceAll('É', 'é');
      // return value;
      return value.length <= 20? value : value.toString().substr(0, 20) + '.';
    }
    
    let data = [], label = [], count = [];

    tempData.forEach(val => {
      label.push(parseLabelName(val.label));
      data.push(val.data);
      count.push(val.count);
    });

    // console.log('calculate data before', data);

    let data2017 = [], data2018 = [], data2019 = [], data2020 = [];
    data.forEach(val => {
      data2017.push(val['2017']);
      data2018.push(val['2018']);
      data2019.push(val['2019']);
      data2020.push(val['2020']);
    });

    // console.log('calculate data after', data2017, data2018, data2019, data2020);

    setPrizesChartData({
      label: label,
      data: {
        '2017': data2017,
        '2018': data2018,
        '2019': data2019,
        '2020': data2020
      },
    });

    // console.log('calculate prizes chart data -> ', data);

    calculateWeightChartData(count);
    calculateListViewData(tempData, prizesData);
  }

  const calculateRadarChartData = (radarData) => {
    let tempData = {
      'AFFAIRES PUBLIQUES' : 0,
      'ANIMATION' : 0,
      'DOCUMENTAIRE' : 0,
      'JEUNESSE' : 0,
      'MAGAZINE' : 0,
      'REPORTAGE' : 0,
      'SPORT' : 0,
      'VARIÉTÉ' : 0,
      'TOUTES CATÉGORIES' : 0, 
      'TALK-SHOW' : 0,
      'HUMOUR' : 0,
      'FICTION-MASCULIN' : 0,
      'FICTION-FEMININ' : 0,
      'FICTION' : 0
    };

    radarData.map(val => {
      tempData[val[filters[1]]]++;
    });

    
    // console.log('tempData', tempData);

    let radar = [];
    let sum = 0;
    for(let obj in tempData) {
      radar.push(tempData[obj]);
      sum += tempData[obj];
    }

    // console.log('sum', sum);
    // console.log('radar', radar);

    for(let index = 0; index < radar.length; index++) {
      radar[index] = ((radar[index] / sum) * 100).toFixed(2);
    }

    // console.log('radar', radar);
    setRadarChartData(radar);
  }

  /*
  const [bottomChartData, setBottomChartData] = useState({
    label: '',
    data: ''
  });

  Not required - counts number of companies in a particular
  const calculateBottomChartData = (bottomData) => {
    
    let tempData = {
     '1': [],
     '2': [],
     '3': [],
     '4': [],
     '5': [],
     '[6-10[': [],
     '[10-15[': [],
     '[15-20[': [],
     '[20-25[': [],
     '[25-30[': [],
     '[30-35[': [],
     '[35-40[': [],
     '[40-45[': [],
     '[45-50[': [],
     '[50-55[': [],
     '[55-60[': [],
     '> 60': []
    };


    bottomData.map(val => {
      //Checking whether hash set under particular category already
      //contains a company or not
      //console.log(val[filters[5]]);
      const indexHash = tempData[val[filters[5]]].findIndex(obj => {
        return obj === val[filters[4]]
      });

      if(indexHash === -1) {
       tempData[val[filters[5]]].push(val[filters[4]]);
      }
    });

    let hashData = []
    for(const property in tempData) {
     hashData.push(tempData[property].length);
    }

    setBottomChartData({
     label: [
       '1',
       '2',
       '3',
       '4',
       '5',
       '[6-10[',
       '[10-15[',
       '[15-20[',
       '[20-25[',
       '[25-30[',
       '[30-35[',
       '[35-40[',
       '[40-45[',
       '[45-50[',
       '[50-55[',
       '[55-60[',
       '> 60'
     ],
     data: hashData
   });

  }*/

  //Get data by applying filters
  async function getAndSetData(year, range, theme) {
    GetData(year, range, theme)
      .then((response) => {
        // console.log('response', response);
        if(response.status === 'error') {
          alert(`Couldn\'t load data`);
          return;
        }

        calculatePrizesChartData(response.data);
        // calculateWeightChartData(); -> called from calculatePrizesChartData
        // calculateListViewData(); -> called from calculatePrizesChartData because uses some precalculated values
        // calculateBottomChartData(response.data); -> Not required right now
        calculateRadarChartData(response.data);
      });
  };

  //Load data as soon as web page loads
  useEffect(() => {
    getAndSetData(yearFilter, rangeFilter, themeFilter);
  }, []);

  //Whenever any filter updates, get filtered data and
  //set again
  const yearFilterChange = (value) => {
    const yearFilterTemp = {
      ...yearFilter, 
      [value]: !yearFilter[value]
    }

    setYearFilter(yearFilterTemp);
    getAndSetData(yearFilterTemp, rangeFilter, themeFilter);
  }

  const rangeFilterChange = (value) => {
    const rangeFilterTemp = {
      ...rangeFilter, 
      [value]: !rangeFilter[value]
    }

    setRangeFilter(rangeFilterTemp);
    getAndSetData(yearFilter, rangeFilterTemp, themeFilter);
  }

  const themeFilterChange = (value) => {
    const themeFilterTemp = {
      ...themeFilter,
      [value]: !themeFilter[value]
    }

    setThemeFilter(themeFilterTemp);
    getAndSetData(yearFilter, rangeFilter, themeFilterTemp);
  }

  /* To push data to firebase
  const addData = () => { 
    let temp = [];
    fetch(data)
    .then(() => {
      data.map(element => {
        temp.push(element);
      });
    })
    .then(() => {
      console.log(temp.length)
      temp.map(element => {
        // console.log(element);
        db.collection('data').add(element);
      });
    });
  }*/

  return (
    <div class="mainContent">
      <div>
        <Title />
      </div>
      <div class="container">
        <div class="leftContainer">
          <PrizesAndWeight
            prizesChartData={prizesChartData}
            weightChartData={weightChartData}
            rangeFilterChange={rangeFilterChange}
            yearFilterChange={yearFilterChange}
          />
        </div>
        <div class="rightContainer">
          <div class="listViewDiv">
            <ListView 
              totalCompanies={totalCompanies}
              totalAwards={totalAwards}
              top10={top10}
            />
          </div>
          <div style={{position: 'absolute'}}>
            <RadarChart 
              radarChartData={radarChartData}
              themeFilterChange={themeFilterChange}
            />
          </div>
        </div> 
      </div>
    </div>
  );
}

export default Homepage;
